import { delay } from "redux-saga";
import { put, takeEvery, select, takeLatest, call } from "redux-saga/effects";
import {
    ACTIONS,
    calculateTotals,
    updatingResponse,
    updatedResponse,
    failedUpdatingResponse,
    logout,
    checkVersion,
    checkVersionFailed,
    checkVersionSuccess
} from "./reducer";
import { fetchDataPromise, UnauthorizedError } from "../../utils/index";

// this is a state selector, getting what we need to send our request
function getResponse(state) {
    // send all results

    return {
        response: {
            submitted_pages: state.write_class.submitted_pages,
            current_page_id: state.write_class.current_page_id,
            form: state.write_class.form,
            selected_class: state.write_class.selected_class,
            final_result_id: state.write_class.final_result_id,
            done: state.write_class.done,
            needs_review_accept_page:
                state.write_class.needs_review_accept_page,
            needs_review_reject_page:
                state.write_class.needs_review_reject_page,
            needs_review_reset_page: state.write_class.needs_review_reset_page,
            needs_review_description:
                state.write_class.needs_review_description,
            needs_review_accept_field:
                state.write_class.needs_review_accept_field,
            needs_review_reviewed_field:
                state.write_class.needs_review_reviewed_field
        },
        schema_version_id: state.write_class.schema_version_id,
        done: state.write_class.done,
        needs_review: state.write_class.needs_review,
        approved: state.write_class.approved
    };
}

export function* saveDataAsync() {
    // console.log("saving form data");
    yield put(updatingResponse());

    const requestPayload = yield select(getResponse);

    // console.log("requestPayload:", requestPayload);

    try {
        const response = yield fetchDataPromise(
            "/response/" + requestPayload.schema_version_id,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestPayload)
            }
        );
        const data = yield response.json();
        // console.log("yield request good", data);

        yield put(updatedResponse());
    } catch (error) {
        console.log("request error");
        yield put(failedUpdatingResponse(error));

        if (error instanceof UnauthorizedError) {
            console.log(
                "got an unauthorized error, logging out, redirecting to login page"
            );
            yield put(logout());
        }
    }
}

export function* checkLogin() {
    try {
        // create a timestamp to attach to avoid caching
        const now = Date.now();
        yield fetchDataPromise("/amILoggedIn?t=" + now);
    } catch (error) {
        if (error instanceof UnauthorizedError) {
            yield put(logout(true));
        }
    }
}

export function* checkVersionHandler() {
    try {
        const response = yield fetch(`/manifest.json?t=${new Date() / 1000}`, {
            headers: {
                Accept: "application/json"
            }
        });
        const data = yield response.json();
        if ("version" in data) {
            yield put(checkVersionSuccess(data.version));
        } else {
            yield put(checkVersionFailed());
        }
    } catch (error) {
        if (error instanceof UnauthorizedError) {
            yield put(logout(true));
            yield put(checkVersionFailed());
        }
    }
}

export function* outdatedVersionHandler() {
    try {
        console.log("forcing refresh because application is outdated");
        yield window.location.reload(true); // force refresh without using cache
    } catch (error) {
        if (error instanceof UnauthorizedError) {
            yield put(logout(true));
        }
    }
}

export function* sagaCalculateTotals(action) {
    yield call(delay, 500);
    yield put(calculateTotals());
}

export function* sagaSaveOnSetPage(action) {
    if (action.payload.save === false) {
        return;
    }
    yield call(delay, 500);
    yield saveDataAsync();
    yield put(checkVersion()); // check version after each save
}

export function* sagaSaveAndCheckVersion(action) {
    yield saveDataAsync();
    yield put(checkVersion()); // check version after each save
}

function* watchToSave() {
    yield takeEvery(
        [
            ACTIONS.SUBMIT_AND_SET_PAGE,
            ACTIONS.SET_AND_COMPLETE,
            ACTIONS.GO_BACK,
            ACTIONS.SET_AND_COMPLETE,
            ACTIONS.SET_RESULT
        ],
        sagaSaveAndCheckVersion
    );
}

function* conditionalWatchToSave() {
    yield takeLatest(ACTIONS.SET_PAGE_ANSWERS, sagaSaveOnSetPage);
}

function* watchAndCalculateTotals() {
    yield takeLatest(
        [ACTIONS.SET_PAGE_ANSWERS, ACTIONS.GOT_LAST_STATE],
        sagaCalculateTotals
    );
}

function* watchForLoginCheck() {
    yield takeLatest(ACTIONS.REQUEST_LOGIN_CHECK, checkLogin);
}

function* watchForCheckVersion() {
    yield takeLatest(ACTIONS.CHECK_VERSION, checkVersionHandler);
}

function* watchForOutdatedVersion() {
    yield takeLatest(ACTIONS.OUTDATED_VERSION, outdatedVersionHandler);
}

export const WRITE_CLASS_SAGAS = [
    watchToSave(),
    watchAndCalculateTotals(),
    conditionalWatchToSave(),
    watchForLoginCheck(),
    watchForCheckVersion(),
    watchForOutdatedVersion()
];



// WEBPACK FOOTER //
// ./src/store/WriteClass/saga.js